<template>
  <div class="table-responsive">
    <table class="table table-bordered mb-0">
      <thead>
        <tr>
          <th v-for="t in visibleTotals" :key="t.label">{{ t.label }}</th>
          <th>Grand Total</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-for="t in visibleTotals" :key="t.label">{{ t.amount }}</td>
          <td>{{ grandTotal }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'ReportsTotals',
  props: {
    totals: { type: Array, default: () => [] }
  },
  setup(props) {
    // Grand Total sums every bucket, including one with an empty/unassigned label (matches monolith:
    // app/View/Reports/outgoing.ctp sums before skipping the column render for an empty commit).
    const grandTotal = computed(() =>
      props.totals.reduce((sum, t) => sum + parseFloat(t.amount || 0), 0).toFixed(2)
    )
    const visibleTotals = computed(() => props.totals.filter(t => t.label))
    return { grandTotal, visibleTotals }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/Reports/ReportsTotals.vue